import { Icon } from 'semantic-ui-react';
import { styled } from '@modules/common/components/ThemeProvider/utils';

export const StyledTitle = styled('div')`
  color: #000000de;
`;

export const StyledClientInfo = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const StyledBasicInfo = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledActions = styled('div')``;

export const StyledNameAndId = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const StyledClientActions = styled('div')`
  button {
    width: 40px;
    height: 40px;
  }
`;

export const StyledClientId = styled('code')`
  min-width: 295px;
`;

export const StyledDropdownIcon = styled(Icon)`
  margin-left: -5px !important;
  margin-right: 10px !important;
  margin-top: -5px !important;
`;
